import { observer } from 'mobx-react-lite'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { Box } from '@mui/material'
import { CertificationsCard } from './CertificationsCard'
import { BioCard } from './BioCard'
import { CareerGoalsCard } from './CareerGoalsCard'
import { InterestsCard } from './InterestsCard'

export type CareerCardProps = {
  userId?: string
  initialOpenCertificationForm?: boolean
  initialOpenCareerGoalForm?: boolean
  initialOpenInterestForm?: boolean
}

export const CareerCard = observer(({ userId, initialOpenCertificationForm, initialOpenCareerGoalForm, initialOpenInterestForm }: CareerCardProps) => {
  return (
    <Box sx={styles.root}>
      <CertificationsCard userId={userId} initialOpenForm={initialOpenCertificationForm} />
      <BioCard userId={userId} />
      <AppBox flexDirection='column' gap={20} width='100%' height='100%'>
        <CareerGoalsCard userId={userId} initialOpenForm={initialOpenCareerGoalForm} />
        <InterestsCard userId={userId} initialOpenForm={initialOpenInterestForm} />
      </AppBox>
    </Box>
  )
})

const styles = {
  root: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: 20,
    width: '100%',
  },
}
